/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PaidInputs */

const cs_enum_paid = /** @type {(inputs: Enum_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaplaceno`)
};

const en_enum_paid = /** @type {(inputs: Enum_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Enum_PaidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_paid = /** @type {((inputs?: Enum_PaidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PaidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_paid(inputs)
	return cs_enum_paid(inputs)
});